import script from "./TemplatePreviewCaptionText.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplatePreviewCaptionText.vue?vue&type=script&setup=true&lang=js"

import "./TemplatePreviewCaptionText.vue?vue&type=style&index=0&id=e33e4c9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e33e4c9c"]])

export default __exports__